const loginform = {


	STATE_LOGIN: 1,
	STATE_FORGOT_PASSWORD: 2,

	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,

	/**
	 * Store the login modal.
	 *
	 * @type {object}
	 */
	login_modal: undefined,


	initialized: false,


	/**
	 * Initialize the component.
	 */
	init: function() {

		if ( loginform.initialized ) {
			return;
		}

		loginform.initialized = true;

		loginform.app = new Reef(
			null,
			{
				data: {
					mode: loginform.STATE_LOGIN
				},
				lagoon: true,
			}
		);

	},


	/**
	 * Display the login modal.
	 *
	 * @return {void}
	 */
	display: function() {

		loginform.login_modal = modal.showGeneral( 'Login' );
		loginform.login_modal.innerHTML = loginform.template();
		loginform.login_modal.addEventListener( 'click', loginform.click );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function() {

		const props = loginform.app.data;

		console.log( loginform.app );
		if ( loginform.STATE_FORGOT_PASSWORD === props.state ) {
			return loginform.forgotPasswordTemplate( props );
		}
		return loginform.loginTemplate( props );

	},


	/**
	 * Display the forgot password template.
	 *
	 * @param {object} props The template properties.
	 * @return {string}
	 */
	forgotPasswordTemplate: function( props ) {

		return `
		<h3>Request Temporary Password</h3>
		<form id="login-form" method="POST">

			<label for="login-username">Username</label>
			<input id="login-username" name="login-username" type="text" autocomplete="username" required>

			<div id="login-error" class="p3 bg-red b-br1 f-fw600 m-b4 display-none"></div>

			<input type="submit" value="Request Password" id="submit-password-request" class="button">

		</form>
		<p class="f-fw500"><a href="#login" id="back-to-login">&larr; Back to login</a></p>
		`;
	},


	/**
	 * Display the login template.
	 *
	 * @param {object} props The template properties.
	 * @return {string}
	 */
	loginTemplate: function( props ) {

		return `
		<form id="login-form" method="POST">

			<label for="login-username">Username</label>
			<input id="login-username" name="login-username" type="text" autocomplete="username" required>

			<label for="login-password">Password</label>
			<input id="login-password" name="login-password" type="password" autocomplete="current-password" required placeholder="Password">

			<div id="login-error" class="p3 bg-red b-br2 f-fw600 m-b4 display-none"></div>

			<input type="submit" value="Sign in" id="submit-login" class="button">

		</form>
		<p class="f-fw500">
			<a href="#forgotpassword" id="login-forgot-password">Forgot Password</a>
			<span class="m-x3 o30">|</span>
			<a href="/join/">Need an account? Join &rarr;</a>
		</p>
		`;

	},


	/**
	 * Handle user login.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	handleLogin: function( e ) {

		const login_username = document.getElementById( 'login-username' );
		const login_password = document.getElementById( 'login-password' );
		const login_error = document.getElementById( 'login-error' );
		const username = login_username.value;
		const password = login_password.value;

		login_error.classList.add( 'display-none' );

		members.setUserLoading();

		userbase.signIn(
			{
				username,
				password,
				rememberMe: 'local'
			}
		)
			.then(
				( user ) => {
					modal.close();
					members.setUserLoggedIn( user );
				}
			)
			.catch(
				( e ) => {
					members.resetUserLogStatus();
					members.errorDisplay( e, 'login-error' );
				}
			);

	},


	/**
	 * Handle password request.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	handlePasswordRequest: function( e ) {

		const login_username = document.getElementById( 'login-username' );
		const username = login_username.value;

		userbase.forgotPassword(
			{
				username
			}
		)
			.then(
				() => {
					loginform.app.setData( { state: loginform.STATE_LOGIN } );
					modal.close();
					alert( 'Password Request sent. Check your email.' );
				}
			)
			.catch(
				( e ) => {
					members.errorDisplay( e, 'login-error' );
				}
			);

	},


	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		const target = e.target;
		const id = target.id;

		// console.log( id );

		if ( 'submit-login' === id ) {

			e.preventDefault();

			loginform.handleLogin( e );

			members.disableButton( target );

		}

		if ( 'submit-password-request' === id ) {

			e.preventDefault();

			loginform.handlePasswordRequest();

			members.disableButton( target );

		}

		if ( 'login-forgot-password' === id ) {

			e.preventDefault();

			loginform.app.setData( { state: loginform.STATE_FORGOT_PASSWORD } );
			loginform.login_modal.innerHTML = loginform.template();

		}

		if ( 'back-to-login' === id ) {

			e.preventDefault();

			loginform.app.setData( { state: loginform.STATE_LOGIN } );
			loginform.login_modal.innerHTML = loginform.template();

		}

	},

};